
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import Cookies from "js-cookie";

const BaseURL = process.env.REACT_APP_API_URL;
const token = Cookies.get("authToken");

const DataBase = Cookies.get("Database");
const ProjectIDs = 1;

export const CustomerProSale = createAsyncThunk(
    'Profile/Customer_Pro_Sale ',
    async (data) => {
        try {
            const response = await axios.post(`${BaseURL}/Profile/Customer_Pro_Sale `, {
                FirmIDs: data.Firm,
                DataBase: DataBase,
                ProjectIDs: ProjectIDs,
                AcYearIDs: data.Year,
                AcIDs: data.AcIDs ? data.AcIDs : "",
                GroupMstIDs: data.selectedIds ? data.selectedIds : ""
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                },
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const CustomerProReceipt = createAsyncThunk(
    'Profile/Customer_Pro_Receipt ',
    async (data) => {
        try {
            const response = await axios.post(`${BaseURL}/Profile/Customer_Pro_Receipt `, {
                FirmIDs: data.Firm,
                DataBase: DataBase,
                ProjectIDs: ProjectIDs,
                AcYearIDs: data.Year,
                AcIDs: data.AcIDs ? data.AcIDs : "",
                GroupMstIDs: data.GroupMstIDs ? data.GroupMstIDs : ""
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                },
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const CustomerProItemQty = createAsyncThunk(
    'Profile/Customer_Pro_Item_Qty',
    async (data) => {
        try {
            const response = await axios.post(`${BaseURL}/Profile/Customer_Pro_Item_Qty`, {
                FirmIDs: data.Firm,
                DataBase: DataBase,
                ProjectIDs: ProjectIDs,
                AcYearIDs: data.Year,
                GroupMstIDs: data.selectedIds ? data.selectedIds : "",
                AcIDs: data.AcIDs ? data.AcIDs : "",
                StartDate: data.startDate ? data.startDate : "",
                EndDate: data.endDate ? data.endDate : "",
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                },
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const CustomerProItemAmt = createAsyncThunk(
    'Profile/Customer_Pro_Item_Amt',
    async (data) => {
        try {
            const response = await axios.post(`${BaseURL}/Profile/Customer_Pro_Item_Amt`, {
                FirmIDs: data.Firm,
                DataBase: DataBase,
                ProjectIDs: ProjectIDs,
                AcYearIDs: data.Year,
                GroupMstIDs: data.selectedIds ? data.selectedIds : "",
                AcIDs: data.AcIDs ? data.AcIDs : "",
                StartDate: data.startDate ? data.startDate : "",
                EndDate: data.endDate ? data.endDate : "",
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                },
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const CustomerProItemRate = createAsyncThunk(
    'Profile/Customer_Pro_Item_Rate ',
    async (data) => {
        try {
            const response = await axios.post(`${BaseURL}/Profile/Customer_Pro_Item_Rate `, {
                FirmIDs: data.Firm,
                DataBase: DataBase,
                ProjectIDs: ProjectIDs,
                AcYearIDs: data.Year,
                GroupMstIDs: data.selectedIds ? data.selectedIds : "",
                AcIDs: data.AcIDs ? data.AcIDs : "",
                StartDate: data.startDate ? data.startDate : "",
                EndDate: data.endDate ? data.endDate : "",
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                },
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const CustomerProOutstanding = createAsyncThunk(
    'Profile/Customer_Pro_Outstanding',
    async (data) => {
        try {
            const response = await axios.post(`${BaseURL}/Profile/Customer_Pro_Outstanding `, {
                FirmIDs: data.Firm,
                DataBase: DataBase,
                ProjectIDs: ProjectIDs,
                AcYearIDs: data.Year,
                GroupMstIDs: data.selectedIds ? data.selectedIds : "",
                AcIDs: data.AcIDs ? data.AcIDs : "",
                StartDate: data.startDate ? data.startDate : "",
                EndDate: data.endDate ? data.endDate : "",
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                },
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const CustomerSupplierProAcDetail = createAsyncThunk(
    'Profile/Customer_Supplier_Pro_Ac_Detail  ',
    async (data) => {
        try {
            const response = await axios.post(`${BaseURL}/Profile/Customer_Supplier_Pro_Ac_Detail `, {
                AcIDs: data.AcIDs ? data.AcIDs : "",
                DataBase: DataBase,
                ProjectIDs: ProjectIDs,
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                },
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const CustomerSupplierProLedgerMonth = createAsyncThunk(
    'Profile/Customer_Supplier_Pro_Ledger_Month  ',
    async (data) => {
        try {
            const response = await axios.post(`${BaseURL}/Profile/Customer_Supplier_Pro_Ledger_Month  `, {
                FirmIDs: data.Firm,
                DataBase: DataBase,
                ProjectIDs: ProjectIDs,
                AcYearIDs: data.Year,
                GroupMstIDs: data.selectedIds ? data.selectedIds : "",
                AcIDs: data.AcIDs ? data.AcIDs : "",
                StartDate: data.startDate ? data.startDate : "",
                EndDate: data.endDate ? data.endDate : "",
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                },
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const CustomerSupplierProLedgerDetail = createAsyncThunk(
    'Profile/Customer_Supplier_Pro_Ledger_Detail ',
    async (data) => {
        try {
            const response = await axios.post(`${BaseURL}/Profile/Customer_Supplier_Pro_Ledger_Detail  `, {
                FirmIDs: data.Firm,
                DataBase: DataBase,
                ProjectIDs: ProjectIDs,
                AcYearIDs: data.Year,
                GroupMstIDs: data.selectedIds ? data.selectedIds : "",
                AcIDs: data.AcIDs ? data.AcIDs : "",
                StartDate: data.startDate ? data.startDate : "",
                EndDate: data.endDate ? data.endDate : "",
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                },
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const CouSupAcGroupList = createAsyncThunk(
    'FAS/CouSupAcGroupList',
    async (data) => {

        try {
            const response = await axios.post(`${BaseURL}/FAS/CouSupAcGroupList`, {
                FirmIDs: data.Firm,
                DataBase: DataBase,
                ProjectIDs: ProjectIDs,
                AcYearIDs: data.Year,
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                },
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response ? error.response.data : 'Network Error');
        }
    }
);


export const CustomerSlice = createSlice({
    name: 'FAS',
    initialState: {
        CustomerSaledata: null,
        CustomerReceiptdata: null,
        CustomerItemQtydata: null,
        CustomerItemAmtdata: null,
        CustomerItemRatedata: null,
        CustomerOutstandingdata: null,
        CustomerSupplierAcDetaildata: null,
        CustomerSupplierLedgerMonthdata: null,
        CustomerSupplierLedgerDetaildata: null,
        CouSupAcGroupListdata: null,
        status: 'idle',
        error: null,
    },
    reducers: {
        CustomerSaleFun: (state) => {
            state.CustomerSaledata = 'no';
        },
        CustomerReceiptFun: (state) => {
            state.CustomerReceiptdata = 'no';
        },
        CustomerItemQtyFun: (state) => {
            state.CustomerItemQtydata = 'no';
        },
        CustomerItemAmtFun: (state) => {
            state.CustomerItemAmtdata = 'no';
        },
        CustomerItemRate: (state) => {
            state.CustomerItemRatedata = 'no';
        },
        CustomerOutstanding: (state) => {
            state.CustomerOutstandingdata = 'no';
        },
        CustomerSupplierAcDetailFun: (state) => {
            state.CustomerSupplierAcDetaildata = 'no';
        },
        CustomerSupplierLedgerMonthFun: (state) => {
            state.CustomerSupplierLedgerMonthdata = 'no';
        },
        CustomerSupplierLedgerDetailFun: (state) => {
            state.CustomerSupplierLedgerDetaildata = 'no';
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(CustomerProSale.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(CustomerProSale.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.CustomerSaledata = action.payload;
            })
            .addCase(CustomerProSale.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(CustomerProReceipt.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(CustomerProReceipt.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.CustomerReceiptdata = action.payload;
            })
            .addCase(CustomerProReceipt.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })


            .addCase(CustomerProItemQty.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(CustomerProItemQty.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.CustomerItemQtydata = action.payload;
            })
            .addCase(CustomerProItemQty.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })


            .addCase(CustomerProItemAmt.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(CustomerProItemAmt.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.CustomerItemAmtdata = action.payload;
            })
            .addCase(CustomerProItemAmt.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(CustomerProItemRate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(CustomerProItemRate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.CustomerItemRatedata = action.payload;
            })
            .addCase(CustomerProItemRate.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(CustomerProOutstanding.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(CustomerProOutstanding.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.CustomerOutstandingdata = action.payload;
            })
            .addCase(CustomerProOutstanding.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })


            .addCase(CustomerSupplierProAcDetail.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(CustomerSupplierProAcDetail.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.CustomerSupplierAcDetaildata = action.payload;
            })
            .addCase(CustomerSupplierProAcDetail.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(CustomerSupplierProLedgerMonth.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(CustomerSupplierProLedgerMonth.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.CustomerSupplierLedgerMonthdata = action.payload;
            })
            .addCase(CustomerSupplierProLedgerMonth.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })


            .addCase(CustomerSupplierProLedgerDetail.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(CustomerSupplierProLedgerDetail.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.CustomerSupplierLedgerDetaildata = action.payload;
            })
            .addCase(CustomerSupplierProLedgerDetail.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(CouSupAcGroupList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(CouSupAcGroupList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.CouSupAcGroupListdata = action.payload;
            })
            .addCase(CouSupAcGroupList.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })
    },
});

export const { OpeningFan, Tforment, OpBalNetFan, ClosingFas, CustomerSupplierLedgerDetailFun, CustomerSupplierLedgerMonthFun, CustomerSupplierAcDetailFun, CustomerOutstanding, CustomerItemRate, CustomerItemAmtFun, CustomerItemQtyFun, CustomerReceiptFun, CustomerSaleFun } = CustomerSlice.actions;

export default CustomerSlice.reducer;

